var map = {
	"./10.jpg": 562,
	"./2.jpg": 563,
	"./3.jpg": 564,
	"./4.jpg": 565,
	"./5.jpg": 566,
	"./6.jpg": 567,
	"./7.jpg": 568,
	"./8.jpg": 569,
	"./9.jpg": 570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;